// src/routes/ProtectedRoutes.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import LoginAuth from '../services/auth.service';

const COOKIE_KEY = 'admone_cp';

/* helpers */
const readTokens = () => {
  try {
    return JSON.parse(Cookies.get(COOKIE_KEY) || '{}');
  } catch {
    return {};
  }
};

export default function ProtectedRoutes() {
  const location = useLocation();
  const [{ checking, authenticated }, setStatus] = useState({
    checking: true,
    authenticated: false,
  });

  /* run *every* time location changes – covers direct log-out nav too   */
  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      const { accessToken, refreshToken } = readTokens();

      /* 1️⃣  we already have an access token → good to go */
      if (accessToken) {
        if (!cancelled) setStatus({ checking: false, authenticated: true });
        return;
      }

      /* 2️⃣  no access but have refresh → try to swap */
      if (refreshToken) {
        try {
          const { data } = await LoginAuth.RefreshToken({ refreshToken });
          const newAccess  = data?.token?.access?.token;
          const newRefresh = data?.token?.refresh?.token;

          if (newAccess && newRefresh) {
            Cookies.set(
              COOKIE_KEY,
              JSON.stringify({ accessToken: newAccess, refreshToken: newRefresh }),
              { expires: 30 }
            );
            if (!cancelled) setStatus({ checking: false, authenticated: true });
            return;
          }
        } catch (e) {
          console.error('Failed to refresh token:', e);
        }
      }

      /* 3️⃣  otherwise unauthenticated */
      if (!cancelled) setStatus({ checking: false, authenticated: false });
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, [location]); // ← fires again right after you navigate during logout

  /* show nothing (or a spinner) while checking */
  if (checking) return null;

  /* bounce to login (remember where we wanted to go) */
  if (!authenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  /* special root redirect */
  if (location.pathname === '/') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
